module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAArSURBVCiRY2DAAf5P8P3/f4Lvf1zyTLgkCIGRoJERX8jRxEacYDQeKdAIAGFxDl/n2CJfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/add.png
// module id = Zarb
// module chunks = 1